import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetRolePermissionsDirective } from './set-role-permissions.directive';
import { ViewOnlyLockDirective } from './view-only.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SetRolePermissionsDirective, ViewOnlyLockDirective],
  exports: [SetRolePermissionsDirective, ViewOnlyLockDirective]
})
export class DirectivesModule {}
